import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

export interface Filter {
  value: string
  field: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GridChipsFiltersComponent',
  props: {
  filters: {
    default: () => []
  }
},
  emits: ['removeFilter'],
  setup(__props, { emit }) {

const props = __props;



// DEFINE PROPS  ======================================================================================================

// COMPOSABLES   ======================================================================================================
const parsedFilters = computed(() => {
  return props.filters.map(({value, field}) => ({value, field}))
})

// METHODS ============================================================================================================
const removeFilter = (filter: Filter) => {
  emit('removeFilter', {filter})
}


return { __sfc: true,emit, props, parsedFilters, removeFilter }
}

})